<template>
  <b-container>
    <b-card title="مشخصات لینک پرداخت" class="mb-7">
       <b-row>
      <b-col cols="12" md="6" sm="6">
        <b-form-group label="عنوان لینک">
          
         <div class="form-control">
           {{loadedListData.title}}
         </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6" sm="6">
        <b-form-group label="مبلغ هدف (ریال)">
          
           <div class="form-control">
             {{loadedListData.amount!=null ? loadedListData.amount.toLocaleString() : 0}}
           </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" sm="12">
        <b-form-group label="توضیحات">
          
          <div class="form-control">
            {{loadedListData.description}}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    </b-card>
   
      <list-table
      :url="url"
      title="جزئیات لینک پرداخت"
      :fields="fields"
      :params="params"
      :sumPrice="true"
      :back="true"
      :excelroute="true"
    ></list-table>
  </b-container>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";

export default {
  name: "goallinksdetails",
  data() {
    return {
      goallink: {},
      loading: false,
    
      url: "goal-link/"+this.$route.params.id+"/transactions",
         params: [
            {
      label: "از تاریخ",
      field: "dateFrom",
      type: "date-picker",
      },
      {
      label: "تا تاریخ",
      field: "dateTo",
      type: "date-picker",
      },
      {
      label: "نام پرداخت کننده",
      field: "user",
      type: "text",
      },
      {
      label: "مبلغ(ریال)",
      field: "amount",
      type: "number",
      },
      {
      label: "کد رهگیری",
      field: "sale_reference_id",
      type: "text",
      },
      {
      label: "شماره کارت",
      field: "card_holder_pan",
      type: "text",
      },
      {
      label: "شماره تماس",
      field: "mobile",
      type: "text",
      }
      ],
      fields: [
        {
          key: "id",
          label: "کد لینک",
        },
        {
          key: "api.api_description",
          label: "نام پرداخت کننده",
        },
        {
          key: "cost",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        
         {
          key: "sale_reference_id",
          label: "کد رهگیری",
        },
        
         {
          key: "card_holder_pan",
          label: "شماره کارت",
          tdClass: "ltr"
        },
        {
          key: "api.api_mobile",
          label: "شماره تماس",
        },
        {
          key: "created_at",
          label: "تاریخ پرداخت",
          formatter: (value, key, item) => {
            return persianDate.getDate(value);
          },
        },
      ]
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed:{
    loadedListData(){
      return this.$store.getters.loadedListData;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "جزئیات لینک پرداخت" }]);
    
  },
};
</script>


<style>
.ltr{
  direction: ltr;
}
</style>